export enum UserInvitationFeature {
  invoiceApp = 'invoice_app',
  invoiceAppNewUser = 'invoice_app_new_user',
  receiptApp = 'receipt_app',
  receiptAppNewUser = 'receipt_app_new_user'
}
